<header [ngClass]="{'masthead': displayHtml, 'adjust': !displayHtml}"  class="bg-primary text-white text-center">
  @if (displayHtml) {
    <div class="container d-flex align-items-center flex-column" id="headerId">
      <!-- Masthead Avatar Image--><img class="masthead-avatar mb-5" src="{{data.headerImg}}" alt="">
      <!-- Masthead Heading-->
      <h1 class="masthead-heading mb-0 slogan">{{data.headline}}</h1>
      <!-- Icon Divider-->
      <app-icone-divider></app-icone-divider>
      <!-- Masthead Subheading-->
      <p class="pre-wrap masthead-subheading font-weight-light mb-0">
        {{data.body}}
        <div class="atelier"> {{data.footer}}</div>
      </div>
    }
  </header>
